// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.each-organization .info-container, .common-distributor-search .selected-member-container .each-member .info-container {
  font-family: "72-Regular";
}

/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.each-organization .info-container, .common-distributor-search .selected-member-container .each-member .info-container {
  font-family: "72-Regular";
}

.common-distributor-search .memeber-dtls .circle-divider {
  margin-left: 0.2rem;
}
.common-distributor-search .cald_predictive-search-name {
  text-align: left;
  word-break: break-word;
}
.common-distributor-search .distributor-header {
  margin-top: 1rem;
  margin-bottom: 0.3rem;
}
.common-distributor-search .dsPro_search-box {
  margin: 0;
}
.common-distributor-search .side-margin-left {
  margin: 2rem 1rem 0rem 1rem;
}
.common-distributor-search .cald_predictive-search-highlighter:before {
  border: #f3bc44 1px solid;
}
.common-distributor-search .selected-member-container {
  position: static;
  background-color: #ffffff;
  list-style-type: none;
  box-shadow: none;
  overflow: auto;
  width: 100%;
}
.common-distributor-search .selected-member-container .each-member {
  padding: 0rem 1rem;
}
.common-distributor-search .selected-member-container .each-member:hover {
  background-color: #fff;
}
.common-distributor-search .selected-member-container .each-member .info-container {
  font-size: 1.2rem;
  text-align: left;
  color: #2797df;
}
.common-distributor-search .selected-member-container .each-member .info-container .cancel-btn {
  text-decoration: none;
  font-size: 1.2rem;
}
.common-distributor-search .selected-member-container .each-member .info-container .name {
  text-overflow: ellipsis;
  overflow: hidden;
}

.each-organization {
  padding: 0.5rem 1rem;
  height: 3.7rem;
  text-align: left;
  letter-spacing: normal;
  line-height: 3.14rem;
  border-bottom: 0.1rem solid #e5e5e5;
  cursor: pointer;
}
.each-organization:hover {
  background-color: rgba(0, 171, 227, 0.05);
}
.each-organization .info-container {
  font-size: 1.2rem;
  text-align: left;
  color: #2797df;
  display: inline-block;
  width: calc(100% - 5rem);
  padding-left: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.each-organization .info-container .organizationid {
  font-size: 1.4rem;
  text-align: left;
  color: #515559;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/organization-search/organization-search.component.scss","webpack://./src/app/shared/distributor-search/distributor-search.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;ADCA,gHAAA;AAqBA;EACI,yBAAA;AClBJ;;ACJI;EACE,mBAAA;ADON;ACJE;EACE,gBAAA;EACA,sBAAA;ADMJ;ACJE;EACI,gBAAA;EACA,qBAAA;ADMN;ACJE;EACE,SAAA;ADMJ;ACJE;EACE,2BAAA;ADMJ;ACJE;EACE,yBAAA;ADMJ;ACJE;EACE,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;ADMJ;ACLI;EACE,kBAAA;ADON;ACNM;EACE,sBAAA;ADQR;ACNM;EAEE,iBAAA;EACA,gBAAA;EACA,cAAA;ADOR;ACNQ;EACE,qBAAA;EACA,iBAAA;ADQV;ACNQ;EACE,uBAAA;EACA,gBAAA;ADQV;;AAtDA;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;AAyDF;AAxDE;EACE,yCAAA;AA0DJ;AAxDE;EAEE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAyDJ;AAxDI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AA0DN","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n@import '../distributor-search/distributor-search.component.scss';\n.each-organization {\n  padding: 0.5rem 1rem;\n  height: 3.7rem;\n  text-align: left;\n  letter-spacing: normal;\n  line-height: 3.14rem;\n  border-bottom: 0.1rem solid #e5e5e5;\n  cursor: pointer;\n  &:hover {\n    background-color: rgba(0, 171, 227, 0.05);;\n  }\n  .info-container {\n    @extend %font-regular;   \n    font-size: 1.2rem;\n    text-align: left;\n    color: #2797df;\n    display: inline-block;\n    width: calc(100% - 5rem);\n    padding-left: 0.5rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    .organizationid {\n      font-size: 1.4rem;\n      text-align: left;\n      color: #515559;\n    }  \n  }\n}\n","@import '../../assets/css/fonts';\n.common-distributor-search{\n  // margin-left: -0.5rem;\n  .memeber-dtls{\n    .circle-divider{\n      margin-left: 0.2rem;\n    }\n  }\n  .cald_predictive-search-name{\n    text-align: left;\n    word-break: break-word;\n  }\n  .distributor-header {\n      margin-top: 1rem;\n      margin-bottom: 0.3rem;\n  }\n  .dsPro_search-box {\n    margin: 0;\n  }\n  .side-margin-left {\n    margin: 2rem 1rem 0rem 1rem;\n  }\n  .cald_predictive-search-highlighter:before{\n    border: #f3bc44 1px solid;\n  }\n  .selected-member-container{\n    position: static;\n    background-color: #ffffff;\n    list-style-type: none;\n    box-shadow: none;\n    overflow: auto;\n    width: 100%;\n    .each-member{\n      padding: 0rem 1rem;\n      &:hover{\n        background-color: #fff;\n      }\n      .info-container{\n        @extend %font-regular;\n        font-size: 1.2rem;\n        text-align: left;\n        color: #2797df;\n        .cancel-btn{\n          text-decoration: none;\n          font-size: 1.2rem;\n        }\n        .name{\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
